import { render } from "./ExpensesPayments.vue?vue&type=template&id=3fe128ce&scoped=true"
import script from "./ExpensesPayments.vue?vue&type=script&lang=js"
export * from "./ExpensesPayments.vue?vue&type=script&lang=js"

import "./ExpensesPayments.vue?vue&type=style&index=0&id=3fe128ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe128ce"]])

export default __exports__